import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "success",
    "danger",
    "warning",
    "custom",
    "info"
  ])
};

const Alert = ({ variant, children, ...props }) => {
  /**
   * variable
   */
  const variantProps = (() => {
    switch (variant) {
      case "primary":
      case "success":
        return { border: "var(--bs-primary-40)", bg: "var(--bs-primary-10)" };
      case "warning":
        return { border: "var(--bs-yellow-40)", bg: "var(--bs-yellow-10)" };
      case "danger":
        return { border: "var(--bs-red-40)", bg: "var(--bs-red-40)" };
      default:
        return {};
    }
  })();

  return (
    <Wrapper role="alert" {...{ ...variantProps, ...props }}>
      {children}
    </Wrapper>
  );
};

/**
 * styles
 */
const Wrapper = styled.div`
  gap: 0.5rem;
  display: flex;
  padding: 0.5rem;
  font-size: 0.75rem;
  border-radius: 2px;
  align-items: center;
  color: var(--bs-black-80);

  border: solid 1px ${({ border }) => border || "var(--bs-gray)"};
  background: ${({ bg }) => bg || "var(--bs-gray-10)"};
`;

Alert.propTypes = propTypes;

export default Alert;
